import GameField from "./GameField";
import {useCallback, useEffect, useState} from "react";
import Confetti from "react-confetti";
import { SocialIconsRow } from "./SocialIcons";

const Game = ({ gameState, saveSpace }) => {
  const [assignments, setAssignments] = useState();
  const [wonGame, setWonGame] = useState(false);

  function prepareAssignments(states) {
    let cardFlipindex = 0;

    const result = gameState?.assignments.map((assignment, index) => {
      const checked =
        states && states[index] !== undefined ? states[index] : false;

      if (!checked) {
        cardFlipindex++;
      }

      return {
        text: assignment.text,
        type: assignment.type,
        password: assignment.password || null,
        checked: states && states[index] !== undefined ? states[index] : false,
        unlocked: states && states[`unlocked_${index}`] ? true : false,
        index: index,
        flipIndex: cardFlipindex,
      };
    });

    setAssignments(result);
  }
  const cachedPrepareAssignments = useCallback(prepareAssignments,[gameState])

  useEffect(() => {
    const storageKey = `2026_${gameState.gameId}`;
    const storedData = localStorage.getItem(storageKey);

    if (storedData) {
      cachedPrepareAssignments(JSON.parse(storedData));
    } else {
      cachedPrepareAssignments();
    }
  }, [gameState, cachedPrepareAssignments]);

  //update checked status
  function updateAssignment(state, index) {
    setAssignments((prev) =>
      prev.map((assignment) =>
        assignment.index === index
          ? { ...assignment, checked: !assignment.checked }
          : assignment,
      ),
    );
  }

  //unlock password tile
  function unlockAssignment(index) {
    setAssignments((prev) =>
      prev.map((assignment) =>
        assignment.index === index
          ? { ...assignment, unlocked: true }
          : assignment,
      ),
    );
  }

  //check is game is won
  useEffect(() => {
    if (assignments && assignments.length > 0) {
      const allChecked = assignments.every((item) => item.checked);
      setWonGame(allChecked);
    }
  }, [assignments]);

  //save last game
  useEffect(() => {
    if (assignments) {
      const checkedState = assignments.map((item, index) => {
        const state = { [index]: item.checked };
        if (item.unlocked) state[`unlocked_${index}`] = true;
        return state;
      });
      localStorage.setItem(
        `2026_${gameState.gameId}`,
        JSON.stringify(Object.assign({}, ...checkedState)),
      );
    }
  }, [assignments, gameState]);

  return (
    <div className="container">
      <div className="row g-1 ">
        {assignments &&
          assignments.map((assignment, index) => (
            <GameField
              key={index}
              assignment={assignment}
              index={index}
              updateAssignment={updateAssignment}
              unlockAssignment={unlockAssignment}
            />
          ))}

        <div
          className={`instagram-astrix d-flex align-items-center justify-content-center ${saveSpace ? "" : "pt-2"}`}
        >
          <span style={{ fontSize: saveSpace ? "0.9rem" : "" }}>
            Deel op
          </span>
          <SocialIconsRow
            className={`social-icons-inline ${saveSpace ? "social-icons-inline-sm" : ""}`}
          />
          <a
            href="https://www.instagram.com/opwekkingteenzone/"
            target="_blank"
            rel="noreferrer"
            className="text-white"
            style={{ fontSize: saveSpace ? "0.9rem" : "" }}
          >
            @opwekkingteenzone
          </a>
        </div>

        {wonGame && <Confetti />}
      </div>
    </div>
  );
};

export default Game;
